import { ElNotification } from "element-plus";

/**
 * Receives an object containing title, message, and type for the message and shows the message
 */
export const showMessage = ({ title, message, type }) => {
  ElNotification({
    title: title,
    message: message,
    type: type,
    duration: 5000,
    zIndex: 4000,
  });
};

/**
 * Receives an object containing just title and message for the message and shows the notification
 */
export const showNotification = ({ title, message }) => {
  ElNotification({
    title: title,
    message: message,
    duration: 5000,
    zIndex: 4000,
  });
};
